module.exports = __webpack_public_path__ + "img/cbj-home.b8fa9fde.jpg";